import {getStartpageBaseOrigin, getUrlParameterByName} from './url'
import {getCookieValue, decodeStartpagePreferences} from './cookie'

export const possibleThemes = new Set(['light', 'air', 'dark', 'night'])

export const lightThemes = new Set(['light', 'air'])

const baseOrigin = getStartpageBaseOrigin()

export const themes = {
    light: {
        menu: {
            settingsIcon: `${baseOrigin}/sp/cdn/images/menu-settings.svg`,
            searchIcon: `${baseOrigin}/sp/cdn/images/menu-startpage-search.svg`,
            browserIcon: `${baseOrigin}/sp/cdn/images/menu-startpage-browser.svg`,
            extensionIcon: `${baseOrigin}/sp/cdn/images/menu-extension.svg`,
            vanishIcon: `${baseOrigin}/sp/cdn/images/menu-vanish.svg`,
        },
        primaryTextColor: '#202945',
        secondaryTextColor: '#2e39b3',
        tertiaryTextColor: '#7F869E',
        quaternaryTextColor: '#7F869E',
        quintaryTextColor: '#5B627A',
        heroTextColor: '#fff',
        linkColor: '#6573ff',
        heroBackgroundColor: '#6573ff',
        lighterBackgroundColor: '#fff',
        darkerBackgroundColor: '#FBFBFD',
        darkerBackgroundColor2: '#FBFBFD',
        emphasisBackgroundColor: '#2e39b3',
        emphasisTextColor: '#6573ff',
        whiteFilter: '',
        quoteTextColor: '#fff',
        quoteBackgroundColor: '#202a45',
        whisper: '#FBFBFB',
        primaryBackgroundColor: '#FFFFFF',
        secondaryBackgroundColor: '#FBFBFB',
        highlightBackgroundColor: '#F2F3FF',
        submitBackgroundColor: '#F2F3FF',
        chartBorderColor: '#FFFFFF',
        boxBorderColor: '#EBECF7',
        brandBlue: '#6573ff',
        brandBlueLight: '#DAE0FF',
        brandBlueAlt: '#384775',
        submitColor: '#384775',
        heroMaskColor: '#DAE0FF',
        oddListItem: '#F5F5FB',
        error: '#8f0c12',
        headerLinkColor: '#374677',
        borderRadius: '4px',
        borderColor: '#dee0f7',
        borderRight: '#ebecf7',
        borderHover: '#6573ff',
        productButtonColor: '#FDB22B',
        heroGradientFirst: '#7985FF',
        heroGradientLast: '#525FE7',
        ourValuesBackground: '#FBFBFB',
        ourValuesItems: '#fff',
        ourTeamBackground: '#fff',
        ourProductsBackground: '#fff',
        ourProductsItems: '#fff',
        ourOrganizationsBackground: '#FBFBFB',
        ourLinksBackground: '#fff',
        ourLinksItems: '#fff',
        placeholder: '#C3C8DA',
        privacyBoxBackground: '#EBECF7',
        privacyBoxBorder: '#EBECF7',
        privacyBackground: '#FBFBFD',
        privacyTabHighlight: '#F2F3FF',
        searchSuggestBackgroundColor: '#ffffff',
        searchSuggestBackgroundHoverColor: '#ebecf7',
        footerLinkColor: '#374677',
        errorRed: '#E23D3D',
        searchButtonUrl: `${baseOrigin}/sp/cdn/images/magnifying-glass-grey.svg`,
        searchButtonUrlHover: `${baseOrigin}/sp/cdn/images/magnifying-glass.svg`,
        privacyBadge: `${baseOrigin}/sp/cdn/images/home/default/privacy-please-badge-new.svg`,
        header: {
            background: '#FFF',
        },
        about: {
            heroBackground1: '#5668F1',
            valuePropBackground: '#fff',
            subsection2TopSquiggleFillColor: '#1E222D',
            subsection2BottomSquiggleFillColor: '#F2F3FF',
            valuePropTextColor: '#1E222D',
            faqCardBackground: '#FFF',
            faqTextColor: '#1E222D',
            valuePropNumberBackground: '#5668F1',
            valuePropNumberTextColor: '#FBFBFD',
            laptop: `${baseOrigin}/sp/cdn/images/laptop.png`,
            shieldDude: `${baseOrigin}/sp/cdn/images/shield-dude.png`,
            cards: [
                {
                    backgroundColor: '#C161EA',
                    textColor: '#FBFBFD',
                },
                {
                    backgroundColor: '#00E7D0',
                    textColor: '#1E222D',
                },
                {
                    backgroundColor: '#FCBB61',
                    textColor: '#1E222D',
                },
                {
                    backgroundColor: '#F77779',
                    textColor: '#1E222D',
                },
            ],
            cardIconBackground: '#1E222D',
            cta4Color: '#2E39B3',
        },
    },
    dark: {
        menu: {
            settingsIcon: `${baseOrigin}/sp/cdn/images/menu-settings-dark.svg`,
            searchIcon: `${baseOrigin}/sp/cdn/images/menu-startpage-search-dark.svg`,
            browserIcon: `${baseOrigin}/sp/cdn/images/menu-startpage-browser-dark.svg`,
            extensionIcon: `${baseOrigin}/sp/cdn/images/menu-extension-dark.svg`,
            vanishIcon: `${baseOrigin}/sp/cdn/images/menu-vanish.svg`,
        },
        primaryTextColor: '#fff',
        secondaryTextColor: '#c5c5c5',
        tertiaryTextColor: '#C3C8DA',
        quaternaryTextColor: '#5B627A',
        quintaryTextColor: '#9297A7',
        heroTextColor: '#cfd1dd',
        linkColor: '#A6AFFF',
        heroBackgroundColor: '#000',
        lighterBackgroundColor: '#171B25',
        darkerBackgroundColor: '#000000',
        darkerBackgroundColor2: '#000000',
        emphasisBackgroundColor: '#6573ff',
        emphasisTextColor: '#A6AFFF',
        whiteFilter: 'brightness(20)',
        quoteTextColor: '#fff',
        quoteBackgroundColor: '#202a45',
        whisper: '#0F1219',
        primaryBackgroundColor: '#171B25',
        secondaryBackgroundColor: '#0F1219',
        brandFontColor: '#A6AFFF',
        highlightBackgroundColor: '#3A445C',
        submitBackgroundColor: '#3B435B',
        chartBorderColor: '#3A445C',
        boxBorderColor: '#3A445C',
        brandBlue: '#6573ff',
        brandBlueLight: '#DAE0FF',
        submitColor: '#EBECF7',
        heroMaskColor: '#252B3B',
        oddListItem: '#252B3B',
        error: '#8f0c12',
        headerLinkColor: '#f2f3fb',
        borderRadius: '4px',
        borderColor: '#3b435b',
        borderRight: '#7f869e',
        borderHover: 'rgb(167, 177, 252)',
        productButtonColor: '#29DDCC',
        heroGradientFirst: '#444FC2',
        heroGradientLast: '#6573FF',
        ourValuesBackground: '#0c0d0f',
        ourValuesItems: '#1E222D',
        ourTeamBackground: '#171b25',
        ourProductsBackground: '#171b25',
        ourProductsItems: '#1E222D',
        ourOrganizationsBackground: '#0c0d0f',
        ourLinksBackground: '#171b25',
        ourLinksItems: '#1E222D',
        placeholder: '#C3C8DA',
        privacyBoxBackground: 'transparent',
        privacyBoxBorder: '#29DDCC',
        privacyBackground: '#0C0D0F',
        privacyTabHighlight: '#0C0D0F',
        searchSuggestBackgroundColor: '#171b25',
        searchSuggestBackgroundHoverColor: '#3a445c',
        footerLinkColor: '#ebecf7',
        errorRed: '#F77779',
        searchButtonUrl: `${baseOrigin}/sp/cdn/images/magnifying-glass-whisper-dark.svg`,
        searchButtonUrlHover: `${baseOrigin}/sp/cdn/images/magnifying-glass-whisper-dark.svg`,
        privacyBadge: `${baseOrigin}/sp/cdn/images/home/dark/privacy-please-badge-new.svg`,
        header: {
            background: '#09090A',
        },
        about: {
            heroBackground1: '#5668F1',
            valuePropBackground: '#09090A',
            subsection2TopSquiggleFillColor: '#1E222D',
            subsection2BottomSquiggleFillColor: '#2E3443',
            valuePropTextColor: '#F2F3FF',
            faqCardBackground: '#09090A',
            faqTextColor: '#F2F3FF',
            valuePropNumberBackground: '#6677FB',
            valuePropNumberTextColor: '#1B1D21',
            laptop: `${baseOrigin}/sp/cdn/images/laptop.png`,
            shieldDude: `${baseOrigin}/sp/cdn/images/shield-dude.png`,
            cards: [
                {
                    backgroundColor: '#D67DFD',
                    textColor: '#1E222D',
                },
                {
                    backgroundColor: '#5AECDE',
                    textColor: '#1E222D',
                },
                {
                    backgroundColor: '#FCBB61',
                    textColor: '#1E222D',
                },
                {
                    backgroundColor: '#F77779',
                    textColor: '#1E222D',
                },
            ],
            cardIconBackground: '#2E3443',
            cta4Color: '#B3BCFF',
        },
    },
}

export const MOBILE_SMALL_WIDTH = 330
export const MOBILE_SMALL_WIDTH_2 = 375
export const MOBILE_SMALL_WIDTH_3 = 410
export const MOBILE_SMALL_WIDTH_4 = 340
export const MOBILE_WIDTH = 650
export const TABLET_WIDTH = 990
export const TABLET_MEDIUM_WIDTH = 865
export const TABLET_SMALL_WIDTH = 810
export const DESKTOP_MEDIUM_WIDTH = 1300
export const HIDE_SIDEBAR_WIDTH = 1250
export const EXPERIMENTAL_HIDE_SIDEBAR_WIDTH = 1274
export const DESKTOP_SMALL_WIDTH = 1230
export const TABLET_LARGE_WIDTH = 1035

export const breakPoints = {
    desktopAndAbove: `min-width: ${TABLET_WIDTH}px`,
    desktopMedium: `max-width: ${DESKTOP_MEDIUM_WIDTH}px`,
    desktopSmall: `max-width: ${DESKTOP_SMALL_WIDTH}px`,
    desktopMediumAndAbove: `min-width: ${DESKTOP_MEDIUM_WIDTH}px`,
    tablet: `max-width: ${TABLET_WIDTH}px`,
    tabletMedium: `max-width: ${TABLET_MEDIUM_WIDTH}px`,
    tabletSmall: `max-width: ${TABLET_SMALL_WIDTH}px`,
    tabletLarge: `max-width: ${TABLET_LARGE_WIDTH}px`,
    hideSidebar: `max-width: ${HIDE_SIDEBAR_WIDTH}px`,
    experimentalHideSidebar: `max-width: ${EXPERIMENTAL_HIDE_SIDEBAR_WIDTH}px`,
    mobile: `max-width: ${MOBILE_WIDTH}px`,
    mobileAndAbove: `min-width: ${MOBILE_WIDTH}px`,
    mobileSmall: `max-width: ${MOBILE_SMALL_WIDTH}px`,
    mobileSmall2: `max-width: ${MOBILE_SMALL_WIDTH_2}px`,
    mobileSmall3: `max-width: ${MOBILE_SMALL_WIDTH_3}px`,
    mobileSmall4: `max-width: ${MOBILE_SMALL_WIDTH_4}px`,
    fullpageMapsRow: 'min-width: 1024px',
}

const themeStylesWithBreakpoints = {
    light: {...themes.light, breakPoints},
    dark: {...themes.dark, breakPoints},
}

const getThemeFromCookie = () => {
    const preferencesCookie = getCookieValue('preferences')
    if (preferencesCookie) {
        const decodedPreferences = decodeStartpagePreferences(preferencesCookie)
        const languageCode = getUrlParameterByName(
            'lang_homepage',
            `http://some-url.com?${decodedPreferences}`, // make it into a url format for the sake of using getUrlParameterByName
        )
        const theme = languageCode.split('/')[1]
        return theme || null
    }
    return null
}

const getThemeFromPfrhUrlParam = () => {
    const preferencesUrl = getUrlParameterByName('prfh')
    if (preferencesUrl) {
        const decodedPreferences = decodeStartpagePreferences(preferencesUrl)
        const languageCode = getUrlParameterByName(
            'lang_homepage',
            `http://some-url.com?${decodedPreferences}`, // make it into a url format for the sake of using getUrlParameterByName
        )
        const theme = languageCode.split('/')[1]
        return theme || null
    }
    const theme = getUrlParameterByName('t')
    return theme
}

export const osPrefersDarkTheme = () => {
    if (typeof window !== `undefined`) {
        // if dark theme css check not supported
        if (!window.matchMedia) return false
        return window.matchMedia('(prefers-color-scheme: dark)').matches
    }
    return false
}

export const getTheme = () => {
    const cookieTheme = getThemeFromCookie()
    const urlTheme = getThemeFromPfrhUrlParam()
    let resolvedTheme
    // in order of preferred
    if (possibleThemes.has(urlTheme)) {
        resolvedTheme = urlTheme
    } else if (possibleThemes.has(cookieTheme)) {
        resolvedTheme = cookieTheme
    }
    if (resolvedTheme === 'air') return 'light'
    if (resolvedTheme === 'night') return 'dark'
    if (resolvedTheme) return resolvedTheme
    if (osPrefersDarkTheme()) return 'dark'
    return 'light'
}

export const getThemeStyles = (themeParam) => {
    const theme = themeParam || getTheme()
    return themeStylesWithBreakpoints[theme] || themeStylesWithBreakpoints.light
}

export const getThemedImage = (images, theme) => {
    // TODO: return "default" for "light" and "dark" for "black"
    // as these images are coming from DatoCMS, update DatoCMS later.
    const simplifiedTheme = lightThemes.has(theme) ? 'default' : 'dark'
    return images.find((img) => img.customData.theme === simplifiedTheme)
}
